var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "19.295 41.295 174.41 129.402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.235 47C180.942 47.0002 188 54.9742 188 64.8105V130.486C188 140.323 180.942 148.297 172.235 148.297H61.8809C61.4528 148.297 61.0288 148.277 60.6094 148.239L25 164.992L46.1162 123.222V64.8105C46.1162 54.9742 53.1742 47.0001 61.8809 47H172.235ZM146 112.676H168.123V106.554H146V112.676ZM66.2695 112.676H136V106.554H66.2695V112.676ZM146 93.752H168.123V87.6299H146V93.752ZM66.2695 93.752H136V87.6299H66.2695V93.752ZM66.2695 74.8291H168.123V68.7061H66.2695V74.8291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.ac0c5fbcc7c8f001483b4af9db6139e7.svg";
export { ForwardRef as ReactComponent };